// src/components/fileUpload/components/FileFormatGuide.jsx
import { FileText, FileDown } from 'lucide-react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { downloadExampleCSV } from '../../utils/fileValidation';

export const FileFormatGuide = () => (
    <div className="w-full sm:w-48 bg-gray-50 rounded-lg p-3">
        <div className="flex flex-col space-y-2">
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                    <FileText className="h-4 w-4 text-blue-500" />
                    <p className="text-xs font-semibold text-gray-600">
                        CSV Format
                    </p>
                </div>
                <TooltipProvider delayDuration={150}>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <button
                                onClick={downloadExampleCSV}
                                className="p-1 hover:bg-gray-100 rounded transition-colors"
                            >
                                <FileDown className="h-4 w-4 text-blue-500" />
                            </button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>Download example CSV</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </div>
            <div className="bg-white border border-gray-200 p-2 rounded text-xs font-mono shadow-sm">
                <span className="text-blue-600">url</span>
                <br />
                <span className="text-gray-600">https://example1.com</span>
                <br />
                <span className="text-gray-600">https://example2.com</span>
                <br />
                <span className="text-gray-600">https://example3.com</span>
            </div>
        </div>
    </div>
);